var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSinatraSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -41 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#shadow_1_);}\n\t.st1{fill:url(#brim_1_);}\n\t.st2{fill:#CEC7BC;}\n\t.st3{fill:url(#crown_1_);}\n\t.st4{fill:url(#side-dent_1_);}\n\t.st5{fill:url(#gutter-dent_1_);}\n\t.st6{fill:url(#ribbon_1_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "shadow_1_",
    cx: 125.9704,
    cy: 125.7092,
    r: 129.9059,
    gradientTransform: "matrix(1 0 0 0.3673 0 79.541)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6938,
    style: {
      stopColor: "#AFADAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    style: {
      stopColor: "#AFADAE",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shadow_4_",
    className: "st0",
    d: "M5,123c0-27.8,56.2-50.3,125.5-50.3C199.8,72.7,256,95.2,256,123c0,27.8-56.2,50.3-125.5,50.3 C61.2,173.4,5,150.8,5,123z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "brim_1_",
    cx: 178.6103,
    cy: 90.8516,
    r: 177.3905,
    gradientTransform: "matrix(-0.9856 0.1689 -9.165681e-02 -0.535 362.9829 109.296)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    style: {
      stopColor: "#F3EFE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    style: {
      stopColor: "#EEEAE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6878,
    style: {
      stopColor: "#E1DBD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8239,
    style: {
      stopColor: "#CDC5B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9626,
    style: {
      stopColor: "#B4AA98"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "brim_4_",
    className: "st1",
    d: "M2.9,127.8c0,0-20.6-40,47.4-62.4C82.1,54.9,119.4,48,152.7,46.8c38-1.3,71.7,5.3,86.4,27.7 c10.6,16.2,4.2,36-16.3,51.4c-12.3,9.2-39.3,18.4-57.3,23.6c-18,5.1-53.3,12-82.2,10.4S18.5,154.1,2.9,127.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "brim_hl",
    className: "st2",
    d: "M2.9,127.8c0,0-20.6-40,47.4-62.4C82.1,54.9,119.4,48,152.7,46.8c38-1.3,71.7,5.3,86.4,27.7 c10.6,16.2,4.2,36-16.3,51.4c-12.3,9.2-39.3,18.4-57.3,23.6c-18,5.1-53.3,12-82.2,10.4S18.5,154.1,2.9,127.8z M83.9,158.7 c28.2,1.6,62.6-5.2,80.1-10.2c17.5-5,44.2-13.6,56.2-22.6c20-15,28.1-33.7,16.9-50.9c-14.2-22-48.7-28.8-85.7-27.5 c-32.4,1.1-68.8,8.8-99.8,19c-66.3,21.9-46.2,60.9-46.2,60.9C20.7,153,55.7,157.1,83.9,158.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.662,
    y1: 47.5795,
    x2: 197.0659,
    y2: 58.4252
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938963,
    style: {
      stopColor: "#D7D0C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    style: {
      stopColor: "#CDC7BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4006,
    style: {
      stopColor: "#C7C2B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5248,
    style: {
      stopColor: "#CBC6BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6688,
    style: {
      stopColor: "#D7D1C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7801,
    style: {
      stopColor: "#E6DFD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8921,
    style: {
      stopColor: "#E7E3D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9337,
    style: {
      stopColor: "#E5DFD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9795,
    style: {
      stopColor: "#DFD5C6"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "crown_4_",
    className: "st3",
    d: "M57.3,95.9c-5.9-4.3-14.2-25.4-11-30c3.2-4.6,8-14.2,10.7-23.6C59.7,33,63.5,13.2,71,6.2 c7.5-7,18.7-7,33.5-5.4c14.7,1.6,57.8,9.4,68.3,13.1c10.4,3.7,24,10.7,23.2,27c-0.8,16.3,0.7,24.4-1.2,33.5 c-1.9,9.1-21.7,26.8-46.6,28.1C123.2,104,63.2,100.2,57.3,95.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "side-dent_1_",
    cx: 110.123,
    cy: 23.7713,
    r: 53.7674,
    gradientTransform: "matrix(8.815892e-02 0.9961 -2.6842 0.2376 164.222 -91.5701)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0671074,
    style: {
      stopColor: "#B2A797"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2897,
    style: {
      stopColor: "#C7BDAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4806,
    style: {
      stopColor: "#D6CEBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6881,
    style: {
      stopColor: "#E2DCD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9423,
    style: {
      stopColor: "#F7F5EE"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "side-dent_2_",
    className: "st4",
    d: "M127.8,75.8c0,0,25.7-3.4,41.2-17.9c15.5-14.5,1.8-24.9-2.4-27.5 c-4.2-2.6-18.3-9.4-40.6-8.4c-22.3,1-44.3,1.2-42.8,17.7C84.7,56.1,102.7,75.8,127.8,75.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gutter-dent_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.277,
    y1: 15.553,
    x2: 177.0614,
    y2: 15.553
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0559668,
    style: {
      stopColor: "#F7F5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2258,
    style: {
      stopColor: "#E6E1D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#D8D1C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6393,
    style: {
      stopColor: "#D0C8B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8566,
    style: {
      stopColor: "#CEC5B5"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "gutter-dent_2_",
    className: "st5",
    d: "M71,26.2c-2.8-1.8-3.2-11.6,7.2-18.3c10.4-6.6,37.2-2.6,54.6,1.6 c17.5,4.2,45.7,10.1,44.2,11.7c-1.5,1.5-43.5-3.6-62.7-2.6C88.2,20,75.4,29,71,26.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ribbon_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.4698,
    y1: 94.5299,
    x2: 196.3752,
    y2: 94.5299
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0184049,
    style: {
      stopColor: "#262222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09587801,
    style: {
      stopColor: "#2F2C2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2998,
    style: {
      stopColor: "#424143"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4017,
    style: {
      stopColor: "#4A4A4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    style: {
      stopColor: "#4A4A4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7797,
    style: {
      stopColor: "#383536"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#262222"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "ribbon_5_",
    className: "st6",
    d: "M195.6,71.7c-0.3,0-0.4,0.9-0.8,1.4c-3.3,5.4-13.1,14.6-35.4,14.6c-19.8,0-51.1,0-60.6,0 c-38.2,0-49.3-10.3-52.1-17.7c-0.2-0.7-0.5-1.6-0.8-1.6c-0.3,0-0.5,1.6-0.5,1.6l-2.9,27.7c0,12.7,32.9,23,75.2,23 c42.3,0,78.6-6,78.6-23c0,0,0.2-16.9,0.1-24.4C196.4,72.5,196.3,71.7,195.6,71.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinatraSvgrepoCom);
export default __webpack_public_path__ + "static/media/sinatra-svgrepo-com.60414ba6249d0a13e33559c5c3c20701.svg";
export { ForwardRef as ReactComponent };